import React, { useState } from 'react';
import { Menu, X, Phone, Mail, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mock';
import QuoteModal from './QuoteModal';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMenuOpen(false);
    }
  };

  const navItems = [
    { label: 'Accueil', id: 'hero' },
    { label: 'Services', id: 'services' },
    { label: 'Vidéo', id: 'video' },
    { label: 'À propos', id: 'about' },
    { label: 'Présence', id: 'franchises' },
    { label: 'Contact', id: 'contact' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-primary backdrop-blur-md shadow-lg">
      {/* Main navigation */}
      <nav className="container mx-auto px-4 py-4" aria-label="Navigation principale">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <button
            onClick={() => scrollToSection('hero')}
            className="flex items-center gap-3 group"
            aria-label="Retour à l'accueil"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_crm-showcase-5/artifacts/ra5fcq1z_4D0C37EB-8A8D-42B6-A180-C7D364245955.png" 
              alt="Logo SESAM" 
              className="h-12 w-auto transition-transform group-hover:scale-105"
            />
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-white hover:text-cyan-200 font-medium transition-colors relative group"
              >
                {item.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-cyan-200 group-hover:w-full transition-all duration-300"></span>
              </button>
            ))}
            <button
              onClick={() => setIsQuoteModalOpen(true)}
              className="bg-white text-primary px-6 py-2.5 rounded-lg hover:bg-cyan-50 transition-all hover:shadow-lg font-medium"
            >
              Devis gratuit
            </button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 hover:bg-white/10 rounded-lg transition-colors text-white"
            aria-label={isMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
            aria-expanded={isMenuOpen}
          >
            {isMenuOpen ? <X size={24} aria-hidden="true" /> : <Menu size={24} aria-hidden="true" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-white/20 pt-4">
            <div className="flex flex-col gap-3">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-left text-white hover:text-cyan-200 font-medium py-2 px-4 hover:bg-white/10 rounded-lg transition-colors"
                >
                  {item.label}
                </button>
              ))}
              <button
                onClick={() => {
                  setIsQuoteModalOpen(true);
                  setIsMenuOpen(false);
                }}
                className="bg-white text-primary px-6 py-3 rounded-lg hover:bg-cyan-50 transition-all font-medium mt-2"
              >
                Devis gratuit
              </button>
              
              {/* Mobile contact info */}
              <div className="mt-4 pt-4 border-t border-white/20 space-y-2">
                <a 
                  href={`tel:${companyInfo.phone[0]}`} 
                  className="flex items-center gap-2 text-sm text-white/90 hover:text-cyan-200"
                >
                  <Phone size={16} aria-hidden="true" />
                  <span>{companyInfo.phone[0]}</span>
                </a>
                <a 
                  href={`mailto:${companyInfo.email}`} 
                  className="flex items-center gap-2 text-sm text-white/90 hover:text-cyan-200"
                >
                  <Mail size={16} aria-hidden="true" />
                  <span>{companyInfo.email}</span>
                </a>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Quote Modal */}
      <QuoteModal 
        isOpen={isQuoteModalOpen}
        onClose={() => setIsQuoteModalOpen(false)}
      />
    </header>
  );
};

export default Header;
